module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQBAMAAADQT4M0AAAAElBMVEUAAAB+rgJ+rgJ+rgJ+rgJ+rgJAu3MfAAAABXRSTlMA50k75G1dACYAAAAnSURBVAjXY1AMBQIhBlEQFcgQygAEoeRTYICggk2BlCiICoRY5AQAiKASY7Mn4IAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-shouji.png
// module id = Lg5N
// module chunks = 101